import { render, staticRenderFns } from "./TrialBalancePaginatedHeader.vue?vue&type=template&id=7921bcb4"
import script from "./TrialBalancePaginatedHeader.vue?vue&type=script&lang=js"
export * from "./TrialBalancePaginatedHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports